import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProductionGuardProps {
  children: React.ReactNode;
}

const ProductionGuard: React.FC<ProductionGuardProps> = ({ children }) => {
  const isProduction = import.meta.env.PROD;

  // Check if SHOW_DASHBOARD is enabled (for PR builds)
  const showDashboard = import.meta.env.VITE_SHOW_DASHBOARD === 'true';

  // In production, redirect to coming soon page unless SHOW_DASHBOARD is enabled
  if (isProduction && !showDashboard) {
    return <Navigate to="/coming-soon" replace />;
  }

  // In development or when SHOW_DASHBOARD is enabled, show the original content
  return <>{children}</>;
};

export default ProductionGuard;
